const es = {
  'successVerifyEmail.button.text': '¡Vamos!',
  'successVerifyEmail.button.noAuthenticated.text': 'Inicia sesión',
  'successVerifyEmail.title': '¡Sí! ¡Tu correo electrónico ha sido verificado!',
  'successVerifyEmail.text': '¡Continuemos con Social Piper!',
};

export default es;
